import {
  LOAD_WIDGET,
  LOAD_WIDGET_FAILURE,
  LOAD_WIDGET_SUCCESS,
  WidgetActionTypes,
  WidgetState,
} from "./widgets.types";

export const initialWidgetState: WidgetState = {
  isLoading: false,
  success: false,
  error: null,
  data: [],
  period: null,
};

export const widgetReducer = (
  state = initialWidgetState,
  action: WidgetActionTypes
) => {
  switch (action.type) {
    case LOAD_WIDGET: {
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
        period: action.payload.period,
      };
    }
    case LOAD_WIDGET_SUCCESS: {
      if (state.period === action.payload.period) {
        return {
          ...state,
          isLoading: false,
          success: true,
          error: null,
          period: action.payload.period,
          data: action.payload.data,
        };
      } else {
        return state;
      }
    }
    case LOAD_WIDGET_FAILURE: {
      if (state.period === action.payload.period) {
        return {
          ...state,
          isLoading: false,
          success: false,
          error: action.payload.error,
          period: action.payload.period,
          data: [],
        };
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};
